/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { GetActiveClientsQuoteQueryResult } from '../model/getActiveClientsQuoteQueryResult';
import { GetComplianceRateQueryResult } from '../model/getComplianceRateQueryResult';
import { GetPendingWorkoutsCountQueryResult } from '../model/getPendingWorkoutsCountQueryResult';
import { InlineResponse404 } from '../model/inlineResponse404';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DashboardService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param teamUid 
     * @param organizationUid 
     * @param isMyClients 
     * @param groupUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardClientsQuoteGet(teamUid?: string, organizationUid?: string, isMyClients?: boolean, groupUid?: string, observe?: 'body', reportProgress?: boolean): Observable<GetActiveClientsQuoteQueryResult>;
    public dashboardClientsQuoteGet(teamUid?: string, organizationUid?: string, isMyClients?: boolean, groupUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetActiveClientsQuoteQueryResult>>;
    public dashboardClientsQuoteGet(teamUid?: string, organizationUid?: string, isMyClients?: boolean, groupUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetActiveClientsQuoteQueryResult>>;
    public dashboardClientsQuoteGet(teamUid?: string, organizationUid?: string, isMyClients?: boolean, groupUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (teamUid !== undefined && teamUid !== null) {
            queryParameters = queryParameters.set('TeamUid', <any>teamUid);
        }
        if (organizationUid !== undefined && organizationUid !== null) {
            queryParameters = queryParameters.set('OrganizationUid', <any>organizationUid);
        }
        if (isMyClients !== undefined && isMyClients !== null) {
            queryParameters = queryParameters.set('IsMyClients', <any>isMyClients);
        }
        if (groupUid !== undefined && groupUid !== null) {
            queryParameters = queryParameters.set('GroupUid', <any>groupUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetActiveClientsQuoteQueryResult>('get',`${this.basePath}/Dashboard/ClientsQuote`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param teamUid 
     * @param organizationUid 
     * @param isMyClients 
     * @param startDateLocal 
     * @param endDateLocal 
     * @param groupUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardComplianceRateGet(teamUid?: string, organizationUid?: string, isMyClients?: boolean, startDateLocal?: string, endDateLocal?: string, groupUid?: string, observe?: 'body', reportProgress?: boolean): Observable<GetComplianceRateQueryResult>;
    public dashboardComplianceRateGet(teamUid?: string, organizationUid?: string, isMyClients?: boolean, startDateLocal?: string, endDateLocal?: string, groupUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetComplianceRateQueryResult>>;
    public dashboardComplianceRateGet(teamUid?: string, organizationUid?: string, isMyClients?: boolean, startDateLocal?: string, endDateLocal?: string, groupUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetComplianceRateQueryResult>>;
    public dashboardComplianceRateGet(teamUid?: string, organizationUid?: string, isMyClients?: boolean, startDateLocal?: string, endDateLocal?: string, groupUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (teamUid !== undefined && teamUid !== null) {
            queryParameters = queryParameters.set('TeamUid', <any>teamUid);
        }
        if (organizationUid !== undefined && organizationUid !== null) {
            queryParameters = queryParameters.set('OrganizationUid', <any>organizationUid);
        }
        if (isMyClients !== undefined && isMyClients !== null) {
            queryParameters = queryParameters.set('IsMyClients', <any>isMyClients);
        }
        if (startDateLocal !== undefined && startDateLocal !== null) {
            queryParameters = queryParameters.set('StartDateLocal', <any>startDateLocal);
        }
        if (endDateLocal !== undefined && endDateLocal !== null) {
            queryParameters = queryParameters.set('EndDateLocal', <any>endDateLocal);
        }
        if (groupUid !== undefined && groupUid !== null) {
            queryParameters = queryParameters.set('GroupUid', <any>groupUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetComplianceRateQueryResult>('get',`${this.basePath}/Dashboard/ComplianceRate`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param currentDateLocal 
     * @param isMyClients 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dashboardPendingWorkoutsGet(currentDateLocal?: string, isMyClients?: boolean, observe?: 'body', reportProgress?: boolean): Observable<GetPendingWorkoutsCountQueryResult>;
    public dashboardPendingWorkoutsGet(currentDateLocal?: string, isMyClients?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetPendingWorkoutsCountQueryResult>>;
    public dashboardPendingWorkoutsGet(currentDateLocal?: string, isMyClients?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetPendingWorkoutsCountQueryResult>>;
    public dashboardPendingWorkoutsGet(currentDateLocal?: string, isMyClients?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (currentDateLocal !== undefined && currentDateLocal !== null) {
            queryParameters = queryParameters.set('CurrentDateLocal', <any>currentDateLocal);
        }
        if (isMyClients !== undefined && isMyClients !== null) {
            queryParameters = queryParameters.set('IsMyClients', <any>isMyClients);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetPendingWorkoutsCountQueryResult>('get',`${this.basePath}/Dashboard/PendingWorkouts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
